import { render } from "./button-container.vue?vue&type=template&id=27972e48&scoped=true"
import script from "./button-container.vue?vue&type=script&lang=js"
export * from "./button-container.vue?vue&type=script&lang=js"

import "./button-container.vue?vue&type=style&index=0&id=27972e48&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27972e48"]])

export default __exports__